import { Route, Switch } from "wouter";
import Login from "../pages/auth/Login";
import CfxreCallback from "../pages/auth/CfxreCallback";
import AddMasterPin from "../pages/auth/AddMasterPin";
import AddMasterCallback from "../pages/auth/AddMasterCallback";
import { Card } from "../components/ui/card";
import { ScLabsLogo } from "@/components/Logos";
import { useThemedImage } from "@/hooks/theme";
import { handleExternalLinkClick } from "@/lib/navigation";
import { AuthError } from "@/pages/auth/errors";

function AuthContentWrapper({ children }: { children: React.ReactNode }) {
    return (
        <div className="text-center">
            {children}
        </div>
    );
}

export default function AuthShell() {
    const customLogoUrl = useThemedImage(window.txConsts.providerLogo);

    return (
        <Switch>
            {/* If it's the login route, let Login.tsx handle its own full-screen layout 
                to avoid layout nesting bugs (open space block) and duplicate txAdmin logos */}
            <Route path="/login">
                <Login />
            </Route>

            {/* Other auth routes (e.g. Master account creation, Cfxre callback) use the wrapper */}
            <Route>
                <div className="min-h-screen flex items-center justify-center pattern-dots">
                    <div className="w-full min-w-[20rem] xs:max-w-[25rem] my-4 xs:mx-4">
                        <div className="flex flex-col items-center gap-2 mb-2">
                            <div className="w-12 h-12 rounded-2xl bg-[rgba(0,255,209,0.08)] border border-[rgba(0,255,209,0.2)] flex items-center justify-center shadow-[0_0_20px_rgba(0,255,209,0.1)]">
                                <i className="fa-solid fa-shield-halved text-[#00ffd1] text-xl" />
                            </div>
                            <div className="text-center">
                                <div className="text-lg font-black text-white uppercase tracking-tight">SC <span className="text-[#00ffd1]">Labs</span></div>
                                <div className="text-[9px] font-mono text-slate-500 tracking-[0.2em]">COMMAND DECK</div>
                            </div>
                        </div>

                        <Card className="min-h-80 mt-4 xs:mt-8 mb-4 flex items-center justify-center bg-card/40 rounded-none xs:rounded-lg">
                            <Switch>
                                <Route path="/login/callback">
                                    <AuthContentWrapper>
                                        <CfxreCallback />
                                    </AuthContentWrapper>
                                </Route>
                                <Route path="/addMaster/pin">
                                    <AuthContentWrapper>
                                        <AddMasterPin />
                                    </AuthContentWrapper>
                                </Route>
                                <Route path="/addMaster/callback">
                                    <AuthContentWrapper>
                                        <AddMasterCallback />
                                    </AuthContentWrapper>
                                </Route>
                                <Route path="/:fullPath*">
                                    <AuthContentWrapper>
                                        <AuthError
                                            error={{
                                                errorTitle: '404 | Not Found',
                                                errorMessage: 'Something went wrong.',
                                            }}
                                        />
                                    </AuthContentWrapper>
                                </Route>
                            </Switch>
                        </Card>

                        <div className="text-center text-[10px] font-mono text-slate-700 mt-2">
                            SC Labs Panel · Secure Connection
                        </div>
                    </div>
                </div>
            </Route>
        </Switch>
    );
}
